import { Button, StandardDialog, TextField } from '@roc/ui';
import { NO_ACTION } from '@roc/feature-sow-shared/constants/scopeOfWorkForm';
import { observer } from 'mobx-react';
import { ScopeOfWorkV2FormBaseStore } from '../stores';
import { Typography } from '@material-ui/core';

interface Props {
  store: ScopeOfWorkV2FormBaseStore;
}

export const SubmitRevisionDialog = observer((props: Props) => {
  const { store } = props;

  return (
    <StandardDialog
      open={store.isSubmitForRevisionOpen}
      title="Submit to TPO for Revision"
      maxWidth="md"
      handleClose={() => store.setOpenSubmitRevisionDialog(false)}
      dialogContent={
        <Typography>Are you sure you want to submit this scope of work to TPO for revision?</Typography>
      }
      dialogActions={
        <>
          <Button
            testId="submitReviewCancel"
            style={{ marginRight: '8px' }}
            onClick={() => store.setOpenSubmitRevisionDialog(false)}
            color="primary"
            variant="outlined"
          >
            CANCEL
          </Button>
          <Button
            testId="submitReviewConfirm"
            onClick={() => store.handleMarkAsInRevision(NO_ACTION)}
            color="primary"
            variant="contained"
          >
            CONFIRM
          </Button>
        </>
      }
    />
  );
});

export default SubmitRevisionDialog;